export default __webpack_public_path__ + "static/media/photo--lg--101.332d6a2f.jpg";